import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex)

export default new Vuex.Store({
    state:{
        isThanks: false
    },
    getters:{
        getThanks(state){
            return state.isThanks
        }
    },
    mutations:{
        setThanks(state){
            state.isThanks = true
        },
        closeThanks(state){
            state.isThanks = false
        }
    },
    actions:{
        viewThanks({commit}){
            commit('setThanks')
        },
        closeThanks({commit}){
            commit('closeThanks')
        }
    }
})
